var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.25C3.44772 2.25 3 2.69772 3 3.25V14.75C3 15.3023 3.44772 15.75 4 15.75H4.25C4.80228 15.75 5.25 15.3023 5.25 14.75V3.25C5.25 2.69772 4.80228 2.25 4.25 2.25H4ZM7.74999 2.25C7.19771 2.25 6.74999 2.69772 6.74999 3.25V14.75C6.74999 15.3023 7.19771 15.75 7.74999 15.75H7.99999C8.55228 15.75 8.99999 15.3023 8.99999 14.75V3.25C8.99999 2.69772 8.55228 2.25 7.99999 2.25H7.74999Z",
    fill: "#212121"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.1079,
    y: 2.94315,
    width: 2.25,
    height: 13.5,
    rx: 1,
    transform: "rotate(-19 10.1079 2.94315)",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatches);
export default __webpack_public_path__ + "static/media/batches.773b9e5a6d79d5a6eeecdd9eeeab9da6.svg";
export { ForwardRef as ReactComponent };